import {
  PAYROLL_REPORTS_HEADER,
  PAYROLL_REPORTS_HEADER_SUCCESS,
  PAYROLL_REPORTS_HEADER_FAIL,
  RESET_REPORTS, RESET_REPORTS_SUCCESS, RESET_REPORTS_FAILURE

} from "./actionTypes";

const initialState = {
  getPayrollHeader: null,
  resetPayrol: {},
  loading: false,
  error: {
    message: "",
  },
};

const AdvanceSearchEaringReducer = (state = initialState, action) => {
  if (!action) return state;
  switch (action.type) {
    case PAYROLL_REPORTS_HEADER:
      state = {
        ...state,
        getPayrollHeader: null,
        loading: true,
      };
      break;
    case PAYROLL_REPORTS_HEADER_SUCCESS:
      state = {
        ...state,
        getPayrollHeader: [...action.payload],
        loading: false,
      };
      break;

    case PAYROLL_REPORTS_HEADER_FAIL:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loading: false,
      };
      break;
    case RESET_REPORTS:
      state = {
        ...state,
        loading: true

      }
      break;
    case RESET_REPORTS_SUCCESS:
      state = {
        ...state,
        resetPayrol: action.payload,
        loading: false
      }
      break;
    case PAYROLL_REPORTS_HEADER_FAIL:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loading: false,
      };
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AdvanceSearchEaringReducer;
